import {
  type SortOrderDropdownVocabKey,
  type SortType,
  SORT_ANSWERS_MATCHING,
  SORT_ANSWERS_NON_MATCHING,
  SORT_RELEVANCE,
} from 'src/constants/sortOrder';

export const getActiveSortOption = (
  sortedBy: string,
  options: SortType[],
): SortOrderDropdownVocabKey | undefined => {
  const activeOption = options.find(
    (option: SortType) => option.value === sortedBy,
  );
  return activeOption?.label;
};

export const getSortOptions = (
  baseOptions: SortType[],
  hasQuestion: boolean,
): SortType[] => {
  let sortOptions = [...baseOptions];

  if (hasQuestion) {
    sortOptions = [
      SORT_ANSWERS_MATCHING,
      SORT_ANSWERS_NON_MATCHING,
      ...sortOptions,
    ];
  }

  sortOptions = [SORT_RELEVANCE, ...sortOptions];

  return sortOptions;
};
